import React from 'react'
import { Link } from 'react-router-dom';

import Navbar from '../../components/navbar/navbar'
import FooterTop from '../../components/footer-top';
import Footer from '../../components/footer';
import PageTitle from '../../components/page-title';
import SEO from '../../components/SEO';

import { blogData } from '../../data/data'
import ScrollToTop from '../../components/scroll-to-top';

interface BlogData {
    id: number;
    image: string;
    date: string;
    title: string;
    desc: string;
}

export default function Blog() {
  return (
    <>
       <SEO
         title="Blog Inmobiliario - Noticias y Recursos"
         description="Blog de AMPI Riviera Nayarit. Artículos, noticias y recursos sobre bienes raíces, mercado inmobiliario en Bahía de Banderas, Nuevo Vallarta y Riviera Nayarit."
         path="/blog"
         keywords="blog inmobiliario riviera nayarit, noticias bienes raíces nayarit, mercado inmobiliario bahía de banderas, artículos AMPI"
         noindex={true}
       />
       <Navbar transparent={false}/>
        <PageTitle
          title="Nuestros Artículos"
          subtitle="Descubre las últimas noticias y recursos del sector inmobiliario"
        />

        <section className="gray-simple">
            <div className="container">
                <div className="row">
                    <div className="col text-center">
                        <div className="sec-heading center">
                            <h2>Latest News</h2>
                            <p>We post regulary most powerful articles for help and support.</p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center g-4">
                    {blogData.map((item:BlogData,index:number)=>{
                        return(
                            <div className="col-xl-4 col-lg-4 col-md-6" key={index}>
                                <div className="blog-wrap-grid h-100 shadow">
                                    <div className="blog-thumb">
                                        <Link to={`/blog-detail/${item.id}`}><img src={item.image} className="img-fluid" alt={item.title || 'Artículo del blog'} /></Link>
                                    </div>
                                    <div className="blog-info">
                                        <span className="post-date label bg-seegreen text-light"><i className="ti-calendar"></i>{item.date}</span>
                                    </div>
                                    <div className="blog-body">
                                        <h4 className="bl-title"><Link to={`/blog-detail/${item.id}`}>{item.title}</Link></h4>
                                        <p>{item.desc} </p>
                                        <Link to={`/blog-detail/${item.id}`} className="text-primary fw-medium">Continue<i className="fa-solid fa-arrow-right ms-2"></i></Link>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>

                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        {/* Sprint 6 (F1-004): paginación mock del template eliminada —
                            los links a # no funcionales rompían UX. Se restaurará cuando el blog
                            migre a Firestore (F1-001) con paginación real. */}
                    </div>
                </div>					
            </div>
        </section>
        <FooterTop bg="theme-bg"/>
        <Footer/>

        <ScrollToTop/>
    </>
  )
}
